import { LockOutlined } from '@ant-design/icons'
import { Button, Card, Form, Input, Typography, message } from 'antd'
import { type FC } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { apiChangePassword } from '~/api/adminApi'
import RadupIcon from '~/assets/images/icon.png'
import { showErrors } from '~/utils/helpers'
import '../SignIn/styles.scss'
import { AUTH_TOKEN } from '~/utils/constants'
import { setAuthToken } from '~/store/auth/slice'
import { useDispatch } from 'react-redux'

const { Title } = Typography

const ChangePassword: FC = () => {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const dispatch = useDispatch()
  const queryClient = useQueryClient()
  const changePasswordMutation = useMutation({
    mutationFn: apiChangePassword,
    onError: showErrors,
    onSuccess: () => {
      if (token == null) {
        return
      }

      localStorage.setItem(AUTH_TOKEN, token)
      dispatch(setAuthToken(token))
      queryClient.invalidateQueries({ queryKey: ['profile'] })
      message.success('Your password is updated successfully')
    }
  })

  return (
    <div className="signin-form">
      <img src={RadupIcon} width="120" alt="" />
      <Card variant='outlined' style={{ width: 300 }}>
        <Form
          name="change_password"
          className="login-form"
          initialValues={{ token }}
          onFinish={changePasswordMutation.mutate}
        >
          <Title level={2}>Change Password</Title>
          <Typography.Paragraph>Please provide the new password for your account to continue</Typography.Paragraph>
          <Form.Item name='token' hidden><Input type='text' /></Form.Item>
          <Form.Item
            name="new_password"
            rules={[{ required: true, message: 'Please input your new password!' }, { min: 6 }]}
          >
            <Input
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="New password"
              autoComplete='false'
            />
          </Form.Item>
          <Form.Item
            name="new_password_confirmation"
            dependencies={['password']}
            rules={[
              { required: true, message: 'Please confirm your new password!' },
              ({ getFieldValue }) => ({
                async validator(_, value) {
                  if (value == null || getFieldValue('new_password') === value) {
                    await Promise.resolve(); return
                  }
                  return await Promise.reject(new Error("The password confirmation doesn't match the new password above!"))
                }
              })
            ]}
          >
            <Input
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Confirm new password"
              autoComplete='false'
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" className="login-form-button" loading={changePasswordMutation.isPending}>
              Confirm New Password
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}

export default ChangePassword
